import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { SurveyRedirectLink, SurveyService } from '../surveyService';
import { useStore } from 'vuex';
import MainLayoutView from '@/generic/views/MainLayoutView';
import { loadEnvironment } from '@/generic/layouts/BaseLayout';

export default defineComponent({
    extends: MainLayoutView,
    setup() {
        const route = useRoute();
        const router = useRouter();
        const { query } = route;
        const knowledgeModelAlias = route.params.knowledgeModelAlias?.toString();
        const surveyKey = query.survey_key.toString();
        const projectId = query.project_id.toString();
        const languageCode = query.language_code?.toString() ?? 'en';
        const loading = ref(true);
        const error = ref(null);
        const store = useStore();

        const loadSurvey = async () => {
            const survey = await new SurveyService().getAnonymousSurvey(parseInt(projectId), surveyKey, languageCode);
            if (survey == null || survey.surveyLink == '') {
                redirectToClosedPage(languageCode, knowledgeModelAlias || survey?.knowledgeModelAlias || '');
                return;
            }

            loadEnvironment(knowledgeModelAlias || survey.knowledgeModelAlias);
            survey.projectId = parseInt(projectId);
            store.commit('SET_ANONYMOUS_SURVEY', survey);
            redirectToSurvey(survey);
        };

        const checkInitialHit = async () => {
            const surveyString = localStorage.getItem(`anonymousSurvey:${projectId}`);
            const survey: SurveyRedirectLink = surveyString ? JSON.parse(surveyString) : null;
            if (survey && survey.surveyLink && survey.projectId === parseInt(projectId)) {
                return redirectToSurvey(survey);
            } else {
                await loadSurvey();
            }
        };

        const redirectToClosedPage = (languageCode: string, knowledgeModelAlias: string) => {
            router.push({ name: 'survey-closed', params: { knowledgeModelAlias }, query: { languageCode } });
        };

        const redirectToSurvey = (survey: SurveyRedirectLink) => {
            const alias = knowledgeModelAlias || survey.knowledgeModelAlias;
            const surveyUrl = new URL(survey.surveyLink, window.location.href);
            surveyUrl.pathname = alias ? `/${encodeURIComponent(alias)}/survey` : '/survey';
            document.location = surveyUrl.href;
        };

        onMounted(async () => {
            await checkInitialHit();

            loading.value = false;
        });

        return {
            loading,
            error,
        };
    },
});
